import { Trans } from "react-i18next";
import i18next from "i18next";
import { isValidPhoneNumber } from "react-phone-number-input";
import validator from 'validator';
import {
  getLangCode,
  getDisplayLangCode,
  extractCountryCode,
  getCountryCode,
  getLanguagePrefix
} from "../utils/Internationalization/handleAppInternationalization";
import {
  nativeAppRoutePaths,
  routePath,
  routePrefix,
  WebCustomerRoutePaths
} from "./Routes";
import {
  BONUSPAGE_PROMOTION,
  COUNTRIES_WITH_SDI,
  ECOPROTOKEN_CLAIMS,
  featureSwitchName,
  ONE_TIME_BONUS_DISCOUNT_PLAN_NAME,
  LOCALSESSIONDATAKEYS,
  NATIVE_APP_CLIENT_IDS,
  ONE_TIME_BONUS,
  READY_PROMOTION,
  SIGNUPTYPE,
  SITECORE_TERMS_AND_CONDITION,
  SUBSCRIPTIONKIND,
  USER_DEVICEREGISTRATION_TYPE_KEYS,
  EXPLORE_BROTHER_DEVICES,
  NEED_HELP,
  RECYCLE_FOR_FREE_WITH_BROTHER,
  CONNECT_BENEFITS,
  NATIVE_APP_VERSION_THRESHOLDS,
  USER_ENROLLED_SERVICE_LIST,
  CONTACT_SUPPORT,
  HWINC_DEVICEUSAGE_TYPES,
  BONUS_PAGE_COUNT,
  APP,
  WEB
} from "./AppConstants";
import {
  getFeatureSwitchByKey,
  getLocalSessionData,
  getUserDataByKey,
  getUserSessionData,
  removeLocalSessionData,
  retreiveUserDeviceRegistrationType,
  setLocalSessionData,
  WEB_handleSelectedPlanLocalData
} from "../utils/Authentication/handleUserSession";
import { ENVSettings, EXTERNAL_LINK_ENDPOINT } from "./ENVSettings";
import { languageCodes, multiLingualCountries } from "./Country";
import { printerTypes } from "./PrinterTypes";
import { DisplayDate } from "../utils/DisplayDate";
import { userRoles } from "./UserRoles";
import SubscriptionOrderPayload from "../utils/MyAccount/SubscriptionOrderPayload";
import { ENROLLMENT_TYPE } from "./AppConstants";

export const getPromotionsArray = (deviceModel, bonusPagesFeature) => {
  const promotions = [];

  if (deviceModel && deviceModel[deviceModel.length - 1] === "E") {
    promotions.push(READY_PROMOTION.promotion);
  }
  if (bonusPagesFeature) {
    promotions.push(BONUSPAGE_PROMOTION.promotion);
  }
  else {
    const plans = WEB_handleSelectedPlanLocalData('Get');
    const OneTimeBonus = ONE_TIME_BONUS

    if (plans && plans.discount) {
      const hasBonusPageDiscount = plans.discount.some(
        (discount) => discount.name === OneTimeBonus
      );

      if (hasBonusPageDiscount) {
        promotions.push(BONUSPAGE_PROMOTION.promotion);
      }
    }
  }

  return promotions.length > 0 ? promotions : null;
};

export const addPromotionsToPayload = (payload, promotion) => {

  if (!promotion || promotion.length === 0) {
    return;
  }
  if (!payload.params) {
    payload.params = {};
  }

  if (promotion.length === 1) {

    payload.params.promotions = promotion[0];
  } else {
    promotion.forEach((promo, index) => {
      payload.params[`promotions[${index}]`] = promo;
    });
  }
};


export const getPlanTranslation = (toBeTranslatedData, signup, source, printerTypeFromContent = null) => {
  let printerType;
  if (printerTypeFromContent) {
    printerType = printerTypeFromContent
  }
  else {
    printerType = getLocalSessionData(LOCALSESSIONDATAKEYS.PRINTER_TYPE)
  }
  let freeTrialMonths = ""
  if (toBeTranslatedData === "6MonthsFree") {
    freeTrialMonths = "6"
  }
  else if (toBeTranslatedData === "XmonthsFreePromotion") {
    freeTrialMonths = "2"
  }
  else if (toBeTranslatedData === "3monthsFreePromotion") {
    freeTrialMonths = "3"
  }
  else if (toBeTranslatedData === "ReadyPromotion") {
    freeTrialMonths = "4"
  }
  if (signup === "web" || signup === "promotionBanner") {
    return <Trans i18nKey="CUSTOMER_WEB.SELECT_PLAN.FREE_TRIAL_MONTHS" freeTrialMonths={freeTrialMonths}>
      Free for {{ freeTrialMonths }} months
    </Trans>
  }
  else {
    const countryCode = getCountryCode();
    let translatedData;
    if (printerType) {
      const formattedPrinterType = printerType.replace(/\s+/g, '')
      const printerKey = `ECOPROCAROUSEL_CONTENT.${formattedPrinterType}.${toBeTranslatedData}`;
      translatedData = i18next.t(printerKey);
    }
    else {
      const key = `ECOPROCAROUSEL_CONTENT.${toBeTranslatedData}`
      translatedData = i18next.t(key);
    }
    // Check if the translation exists or not
    if (translatedData.includes('ECOPROCAROUSEL_CONTENT')) {
      translatedData = toBeTranslatedData;
    }

    // Add double quotes only for sv-SE locale
    if (countryCode === "SE" && source === "dashboard") {
      return `"${translatedData}"`;  // Add double quotes for Swedish
    }

    return translatedData;
  }
};

export const getCarbonSavingTypeTranslation = (carbonSavingType) => {
  if (i18next.t(`CARBON_OFFSETTING.CARBON_SAVING_TYPE.${carbonSavingType?.toUpperCase()?.replace(/ /g, "_")}`)?.includes('CARBON_OFFSETTING.CARBON_SAVING_TYPE')) {
    return carbonSavingType
  }
  else {
    return i18next.t(`CARBON_OFFSETTING.CARBON_SAVING_TYPE.${carbonSavingType?.toUpperCase()?.replace(/ /g, "_")}`)
  }
}

export const findPromotionType = (discounts, signup) => {
  let promotion = ""

  if (signup === "promotionBanner") {
    promotion = getPlanTranslation("6MonthsFree", signup)
  }
  else {
    for (let i = 0; i < discounts.length; i++) {
      if (discounts[i].planName === ONE_TIME_BONUS_DISCOUNT_PLAN_NAME) {
        continue;
      }
      if (discounts[i].planName === READY_PROMOTION.discountName) {
        promotion = getPlanTranslation(discounts[i].planName, signup)
        break;
      }
      promotion = getPlanTranslation(discounts[i].planName, signup);
    }
  }

  return promotion
}

export const getOrderTypeTranslation = (toBeTranslatedData) => {
  if (i18next.t(`DASHBOARD.ORDERS.${toBeTranslatedData}`).includes('DASHBOARD.ORDERS')) {
    return toBeTranslatedData
  }
  else {
    return i18next.t(`DASHBOARD.ORDERS.${toBeTranslatedData}`)
  }
}

const postalCodes = require("postal-codes-js");
export const findzipCodeError = (country, postcode) => {
  const countryCode = extractCountryCode(country);
  if (postalCodes.validate(countryCode, postcode) === true) {
    return false;
  } else {
    return true;
  }
};

export const findMobileError = (mobileNumber) => {
  if (mobileNumber !== undefined) {
    if (isValidPhoneNumber(mobileNumber)) {
      return false;
    } else {
      return true;
    }
  }
  else {
    return true
  }
};

export const validateEmail = (emailAddress) => {
  if (validator.isEmail(emailAddress)) {
    return false
  }
  else {
    return true
  }
}

export const getDefaultCountry = () => {
  let countryCode = getLangCode().split('-')[1]
  return countryCode
}

const checkPath = (pathArr, currentPath, type = null) => {
  if (pathArr.indexOf(currentPath) !== -1) {
    return true
  }
  else {
    return false
  }
}

export const checkHamburgerHeaderLocation = (pageLocation) => {
  const locationPathArr = [
    routePath.DASHBOARD,
    routePath.ORDERS,
    routePath.MY_ACCOUNT,
    routePath.HELP_SUPPORT,
    routePath.CARBON_OFFSETTING,
    routePath.PRINT_ACTIVITY,
    routePath.ECOPRO_FEEDBACK,
    routePath.MY_DEVICES
  ];
  return checkPath(locationPathArr, pageLocation)
}
export const checkEditForm = (pageLocation) => {
  const locationPathArr = [routePath.EDIT_ACCOUNT];
  return checkPath(locationPathArr, pageLocation)
}
export const emptyObjectCheck = (value) => {
  return Object.keys(value).length === 0
    && value.constructor === Object;
}
export const getReasonString = (codeArray) => {
  return (codeArray) ? codeArray.join() : null;
}
export const convertToKG = (data) => {
  return (data / 1000).toFixed(2);
}
export const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}
export const navigateToMobileConnect = () => {
  if (getMobileOperatingSystem() === "iOS") {
    window.location.href = EXTERNAL_LINK_ENDPOINT.iosMobileConnectApp
  }
  else {
    window.location.href = EXTERNAL_LINK_ENDPOINT.androidMobileConnectApp
  }
}

export const getResolvedLocale = () => {

  let countryCode = getCountryCode();
  countryCode = countryCode === "GB" ? "uk" : countryCode;

  const country = countryCode?.toUpperCase();

  let countryCodeWithDefaultLang = languageCodes[countryCode?.toLowerCase()];

  // Primary source
  let lang = getLanguagePrefix();

  // Multilingual handling
  if (multiLingualCountries[country]) {

    // fallback to default if invalid / missing
    if (!multiLingualCountries[country].includes(lang)) {
      lang = multiLingualCountries[country][0];
    }

    const locale = `${lang}-${country}`;

    return {
      countryCodewithLang: locale,
      countryCodeWithDefaultLang: locale
    };
  }

  // Non-multilingual countries
  return {
    countryCodewithLang: `${lang}-${country}`,
    countryCodeWithDefaultLang
  };
};
export const getLocalizedLink = (LINK_OBJECT) => {
  const { countryCodewithLang, countryCodeWithDefaultLang } =
    getResolvedLocale();

  return LINK_OBJECT[countryCodewithLang] || LINK_OBJECT[countryCodeWithDefaultLang];
};

/**
 * Derives lowercase locale for URL usage
 * WITHOUT affecting existing getResolvedLocale
 *
 * Example:
 * "fr-BE" → "fr-be"
 */
export const getResolvedLocaleForUrl = () => {

  const { countryCodewithLang } = getResolvedLocale();

  if (!countryCodewithLang) return "";

  return countryCodewithLang.toLowerCase(); // fr-be
};

export const getPersonalOrBusinessTerms = (bothPersonalAndBusiness = false) => {

  const { countryCodewithLang, countryCodeWithDefaultLang } =
    getResolvedLocale();

  const personalOrBusiness = getUserDataByKey("businessModel");

  if (bothPersonalAndBusiness) {

    return {
      personal: SITECORE_TERMS_AND_CONDITION.personal[countryCodewithLang],
      business: SITECORE_TERMS_AND_CONDITION.business[countryCodewithLang]
    };

  }

  let link;

  if (personalOrBusiness === "1") {
    link = SITECORE_TERMS_AND_CONDITION.business[countryCodewithLang];
  } else {
    link = SITECORE_TERMS_AND_CONDITION.personal[countryCodewithLang];
  }

  return (
    link ||
    SITECORE_TERMS_AND_CONDITION.personal[countryCodeWithDefaultLang]
  );
};

export const getRecycleForFreeWithBrotherLink = () => {
  return getLocalizedLink(RECYCLE_FOR_FREE_WITH_BROTHER);
};

export const getExploreBrotherDevicesLink = () => {
  return getLocalizedLink(EXPLORE_BROTHER_DEVICES);
};

export const getNeedHelpLink = () => {
  return getLocalizedLink(NEED_HELP);
};

export const getConnectBenefitsLink = () => {
  return getLocalizedLink(CONNECT_BENEFITS);
};

export const getContactUsLink = () => {
  return getLocalizedLink(CONTACT_SUPPORT);
};

export const formatNumberOnLocale = (price, currency, locale, isWholeNumber = false) => {
  let langCode;
  if (locale) {
    langCode = locale
  }
  else {
    langCode = getLangCode() || "en-GB";
  }
  const options = {};

  if (isWholeNumber) {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  } else {
    options.minimumFractionDigits = 2;
    options.maximumFractionDigits = 2;
  }

  if (langCode === 'fr-CH' && currency) {
    options.style = 'decimal';
  } else if (currency) {
    options.style = 'currency';
    options.currency = currency;
  } else {
    options.style = 'decimal';
  }

  const formattedPrice = new Intl.NumberFormat(langCode, options).format(price);

  if (langCode === 'fr-CH' && currency) {
    return `CHF ${formattedPrice.replace(/\u00A0/g, ' ')}`;
  }

  return formattedPrice;

}

export const getPrinterTypeTranslation = (printerName, type) => {
  const printerTypesObj = printerTypes
  const PrinterTypeKey = Object.keys(printerTypesObj).find(key => printerTypesObj[key] === printerName);
  if (type === "description") {
    if (i18next.t(`CUSTOMER_WEB.SELECT_PRINTER.DESCRIPTION.${PrinterTypeKey}`).includes('CUSTOMER_WEB.SELECT_PRINTER.DESCRIPTION')) {
      return printerName
    }
    else {
      return i18next.t(`CUSTOMER_WEB.SELECT_PRINTER.DESCRIPTION.${PrinterTypeKey}`)
    }
  }
  else {
    if (i18next.t(`CUSTOMER_WEB.SELECT_PRINTER.${PrinterTypeKey}`).includes('CUSTOMER_WEB.SELECT_PRINTER')) {
      return printerName
    }
    else {
      return i18next.t(`CUSTOMER_WEB.SELECT_PRINTER.${PrinterTypeKey}`)
    }
  }
}
/**
 * Method to authenticate Web signup user through external URL call
 * @return void
 */
export const AuthenticateUserByExternalRedirect = (redirectURL = null) => {
  console.trace();
  const redirect_uri = redirectURL || WebCustomerRoutePaths.USER_ACCOUNT_INFO;
  const domain = (new URL(window.location.href));
  const countryCode = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE).toLowerCase();
  const langCode = getLanguagePrefix();
  const finalURL = `${ENVSettings.BOL_API_BASE_REDIRECT_URL}/api/v1/connected_service/login?client_id=ecoproclient&redirect_uri=${domain.origin}${redirect_uri}&state=state&country=${countryCode}&language=${langCode}`;
  window.location.href = finalURL;
}
export const paymentOptionsNameTranslation = (paymentType) => {
  if (i18next.t(`PAYMENT_OPTIONS.DISPLAY_NAME.${paymentType}`).includes('PAYMENT_OPTIONS.DISPLAY_NAME')) {
    return paymentType
  }
  else {
    return i18next.t(`PAYMENT_OPTIONS.DISPLAY_NAME.${paymentType}`)
  }
}
export const pushDataLayer = (event, parameterName, parameterValue) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': event,
    [parameterName]: parameterValue
  });
}

export const pushMultipleDataLayer = (event, attributes = {}) => {
  if (!attributes || typeof attributes !== 'object') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...attributes
  });
};

export const setClientParameterLocale = (langCode) => {
  const result = langCode?.replace('-', '_')
  return result
}

export const checkEcoproSupportRegion = (postCode, response) => {
  let countryRegexResponse = response[0]
  const countryRegex = new RegExp(countryRegexResponse);
  const isPostCodeRestrict = countryRegex.test(postCode?.toUpperCase());
  return isPostCodeRestrict
}

export const getGradient = (ctx, chartArea, start_color, stop_color) => {
  let width, height, gradient;
  const chartWidth = chartArea.right - chartArea.left;
  const chartHeight = chartArea.bottom - chartArea.top;
  if (gradient === null || width !== chartWidth || height !== chartHeight) {
    width = chartWidth;
    height = chartHeight;
    gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    gradient.addColorStop(0, start_color);
    gradient.addColorStop(0.5, stop_color);
    gradient.addColorStop(1, stop_color);
  }
  return gradient;
};

export const chooseMaxOrMinDate = (
  dateType,
  planData,
  dateDisplayOptions,
  langCode,
  source
) => {
  let dateFiltered;
  if (dateType === "max") {
    dateFiltered = new Date(
      Math.max(
        ...planData?.map((element) => {
          if (source === "brother-plus")
            return new Date(element?.date);
          return new Date(element?.startDate);
        })
      )
    );
  } else {
    dateFiltered = new Date(
      Math.min(
        ...planData?.map((element) => {
          if (source === "brother-plus")
            return new Date(element?.date);
          return new Date(element?.startDate);
        })
      )
    );
  }
  return DisplayDate(dateFiltered, dateDisplayOptions, langCode);
};
export const sortDateInDescendingOrder = (arrayOfObject, source, monthCount) => {
  if (!Array.isArray(arrayOfObject)) {
    return [];
  }
  const sortedArray1 = [...arrayOfObject]?.sort(function (a, b) {
    if (source === "brother-plus")
      return new Date(b.date) - new Date(a.date);

    return new Date(b.startDate) - new Date(a.startDate);
  });
  return sortedArray1.slice(0, monthCount).reverse();
};

export const getChartLabels = (printData, source, monthCount) => {
  const dateDisplayOptions = { month: "short" };
  const endDateDisplayOptions = { month: "short", year: "numeric" }
  // Month names are text the user reads: they follow the UI language (see getChartValues, which must use the same locale).
  const langCode = getDisplayLangCode();
  const d = new Date(
    Math.max(
      ...printData?.map((element) => {
        if (source === "brother-plus") {
          return new Date(element?.date)
        }
        else {
          return new Date(element?.startDate);
        }
      })
    )
  );
  let currentMonth = d.getMonth() + 1;
  let labels = [];
  let endDate = ""
  for (let i = monthCount; i > 0; i--) {
    d.setMonth(currentMonth - i);
    if (i === monthCount) {
      endDate = d?.toLocaleDateString(langCode, endDateDisplayOptions)
    }
    labels.push(d?.toLocaleDateString(langCode, dateDisplayOptions));
  }
  return { labels: labels, endDate: endDate };
};



export const getChartValues = (labels, printData, source, monthCount) => {
  const dateDisplayOptions = { month: "short" };
  // Must match the locale used by getChartLabels, because values are matched on the formatted month name.
  const langCode = getDisplayLangCode();
  let values = [];
  for (let i = 0; i < monthCount; i++) {
    if (labels) {
      if (source === "brother-plus") {
        const filteredChartValues = printData.filter(
          (data) => (
            DisplayDate(data.date, dateDisplayOptions, langCode) === labels[i]
          )
        );
        if (filteredChartValues[0]?.printedPages)
          values.push(filteredChartValues[0]?.printedPages);
        else values.push(0)
      }
      else {
        const filteredChartValues = printData.filter(
          (data) => (
            DisplayDate(data.startDate, dateDisplayOptions, langCode) === labels[i]
          )
        );
        if (filteredChartValues[0]?.printedTotalPages)
          values.push(filteredChartValues[0]?.printedTotalPages);
        else values.push(0)
      }
    }
  }
  return values;
};
export const getYAxesMaxValue = (printData, source) => {
  if (source === "brother-plus") {
    const yAxesMaxValue = Math.max(
      ...printData.map((element) => {
        return element?.printedPages;
      })
    );
    return yAxesMaxValue
  }
  else {
    const yAxesMaxValue = Math.max(
      ...printData.map((element) => {
        return element?.printedTotalPages;
      })
    );
    const planPages = Math.max(
      ...printData.map((element) => {
        return element?.planPages;
      })
    );

    if (planPages > yAxesMaxValue) {
      return planPages
    }
    else return yAxesMaxValue
  }

};
export const getAverageValue = (chartValues) => {
  const filter = array => array.filter((last => v => last = last || v)(false));
  const filteredArray = filter(chartValues)
  if (filteredArray?.length > 0) {
    const sum = filteredArray.reduce((a, b) => a + b);
    const average = sum / filteredArray.length;
    return Math.round(average)
  }
  else {
    return 0
  }
}

export const trimAddressFieldsLength = (txt, trimLength) => {
  return (txt) ? txt.substring(0, trimLength).trim() : null;
}

export const truncateAddressLine1Characters = (string, initialIndex, finalIndex) => {
  const truncatedString = string?.substring(initialIndex, finalIndex)
  return truncatedString
}

export const validateProvinceData = (formData) => {
  return (formData.country && formData.country.toUpperCase() !== 'ITALY') ? "" : formData.province;
}
export const verifyItalyBusinessUser = (country) => {
  const personalOrBusiness = getUserDataByKey('businessModel');
  if (country && COUNTRIES_WITH_SDI.includes(country.toUpperCase()) && personalOrBusiness === "1") {
    return true
  }
  else {
    return false
  }
}

/**
 * Method to avoid page auto scrolling to down in some browser scenarios eg:Firefox 
 * @param string elementClassName 
 * @return void
 */
export const scrollToTop = (elementClassName) => {
  let element = document.querySelector(elementClassName);
  if (element) {
    element.scrollIntoView();
  }
}
export const currentUserRolesArr = () => {
  return (getUserSessionData(ECOPROTOKEN_CLAIMS.ROLES)) ? getUserSessionData(ECOPROTOKEN_CLAIMS.ROLES).split(',') : [];
}
export const validateRoleAndPathname_CSAGENT_ADMIN = (roles, pathname) => {
  return (
    (roles.indexOf(userRoles.ADMIN) > -1 || roles.indexOf(userRoles.CSAGENT_ADMIN) > -1)
    && pathname.indexOf(routePrefix.CSAGENT) > -1)
    ? true : false;
}

export const currentUserRoleByOrder = () => {
  const roles = currentUserRolesArr();
  let currentUserRole = null;
  if (roles.indexOf(userRoles.ADMIN) > -1) {
    currentUserRole = userRoles.ADMIN;
  } else if (roles.indexOf(userRoles.CSAGENT_ADMIN) > -1) {
    currentUserRole = userRoles.CSAGENT_ADMIN
  } else if (roles.indexOf(userRoles.CSAGENT) > -1) {
    currentUserRole = userRoles.CSAGENT
  } else if (roles.indexOf(userRoles.CSAGENT_VIEWER) > -1) {
    currentUserRole = userRoles.CSAGENT_VIEWER
  } else {
    currentUserRole = 'Invalid input'
  }
  return currentUserRole;
}

export const postalCode_ErrorMsg = (errStatus, regionUnSupportedZipError, countryCode) => {
  let errorMsg;
  if (errStatus && !regionUnSupportedZipError) {
    errorMsg = i18next.t("FORM_CONTENT.FORM_ERROR.POSTCODE_VALID")
  } else if (errStatus && regionUnSupportedZipError) {
    if (countryCode === "FR") {
      errorMsg = i18next.t("FORM_CONTENT.FORM_ERROR.FRANCE_POSTCODE_ERROR")
    }
    else {
      errorMsg = i18next.t("FORM_CONTENT.FORM_ERROR.POSTCODE_RESTRICTION")
    }
  }
  else {
    errorMsg = i18next.t("FORM_CONTENT.FORM_ERROR.POSTCODE_EMPTY")
  }
  return errorMsg;
}

export const getPieChartDataWithBonus = (remainingBonusPages, printedTotalPages, printedPlanPages, printedRollover, printedOverage, planPages, givenRolloverPages, purchasedOveragePages, printedBonusPages) => {
  let allInfo = {}
  const bonusPages = remainingBonusPages;
  let monthlyAllowance = bonusPages + planPages + givenRolloverPages + purchasedOveragePages
  let totalPagesUsed = printedBonusPages + printedPlanPages + printedRollover + printedOverage
  let printedBonusColor = 'rgba(163, 73, 164, 1)'
  let printedPlanColor = 'rgba(0, 126, 143, 1)'
  let rollOverColour = 'rgba(69, 129, 232, 1)'
  let overageColor = 'rgba(240, 139, 71, 1)'
  let transparentColor = 'rgba(0, 126, 143, 0.1)'
  let unusedBonusColor = 'rgba(204, 204, 255, 1)';
  let data1;
  let lineSegment;
  let backgroundColor;
  let labels;

  let lineSegment1 = bonusPages
  let lineSegment2 = monthlyAllowance === planPages + bonusPages ? undefined : planPages + bonusPages
  let lineSegment3 = (monthlyAllowance === planPages + givenRolloverPages + bonusPages) ? undefined : planPages + bonusPages + givenRolloverPages
  lineSegment = [lineSegment1, lineSegment2, lineSegment3]
  let unusedPagesLabel;


  if (printedOverage < purchasedOveragePages) unusedPagesLabel = i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_OVERAGE")
  if (printedRollover < givenRolloverPages) unusedPagesLabel = i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_ROLLOVER")
  if (printedPlanPages < planPages) unusedPagesLabel = i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN")

  if (printedBonusPages === 0) {
    if (givenRolloverPages !== 0) {
      data1 = [bonusPages, planPages, givenRolloverPages]
      backgroundColor = [unusedBonusColor, transparentColor, transparentColor]
      labels = [
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_BONUS"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_ROLLOVER")
      ]
    } else {
      data1 = [bonusPages, planPages]
      backgroundColor = [unusedBonusColor, transparentColor]
      labels = [
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_BONUS"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN")
      ]
    }
  }
  else if (printedBonusPages !== 0 && printedBonusPages < bonusPages && printedPlanPages === 0) {
    if (givenRolloverPages !== 0) {
      data1 = [printedBonusPages, bonusPages - printedBonusPages, planPages, givenRolloverPages]
      backgroundColor = [printedBonusColor, unusedBonusColor, transparentColor, transparentColor]
      labels = [
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.BONUS_PAGES_USED"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_BONUS"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_ROLLOVER")
      ]
    } else {
      data1 = [printedBonusPages, bonusPages - printedBonusPages, planPages - printedPlanPages]
      backgroundColor = [printedBonusColor, unusedBonusColor, transparentColor]
      labels = [
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.BONUS_PAGES_USED"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_BONUS"),
        i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN")
      ]
    }
  }
  else if (printedBonusPages === bonusPages && printedPlanPages <= planPages && planPages <= monthlyAllowance && printedRollover === 0 && givenRolloverPages !== 0) {
    data1 = [printedBonusPages, printedPlanPages, (planPages + bonusPages) - (printedBonusPages + printedPlanPages), givenRolloverPages]
    backgroundColor = [printedBonusColor, printedPlanColor, transparentColor, transparentColor]
    labels = [i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.BONUS_PAGES_USED"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.PAGES_USED"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_ROLLOVER")]
  }

  allInfo = {
    data: data1 ? data1 : [printedBonusPages, printedPlanPages, printedRollover, printedOverage, monthlyAllowance - printedTotalPages],
    extra: lineSegment,
    backgroundColor: backgroundColor ? backgroundColor : [printedBonusPages ? printedBonusColor : undefined, printedPlanPages ? printedPlanColor : undefined, printedRollover ? rollOverColour : undefined, printedOverage ? overageColor : undefined, monthlyAllowance - printedTotalPages ? transparentColor : undefined],
    monthlyAllowance: monthlyAllowance,
    totalPagesUsed: totalPagesUsed,
    labels: labels ? labels : [i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.BONUS_PAGES_USED"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.PAGES_USED"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.ROLLOVER"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.OVERAGE"),
      unusedPagesLabel]
  }

  return allInfo
}

export const getPieChartData = (printedTotalPages, printedPlanPages, printedRollover, printedOverage, planPages, givenRolloverPages, purchasedOveragePages) => {
  let allInfo = {}
  let monthlyAllowance = planPages + givenRolloverPages + purchasedOveragePages
  let totalPagesUsed = printedPlanPages + printedRollover + printedOverage
  let printedPlanColor = 'rgba(0, 126, 143, 1)'
  let rollOverColour = 'rgba(69, 129, 232, 1)'
  let overageColor = 'rgba(240, 139, 71, 1)'
  let transparentColor = 'rgba(0, 126, 143, 0.1)'
  let data1;
  let lineSegment;
  let backgroundColor;
  let labels;

  let lineSegment1 = monthlyAllowance === planPages ? undefined : planPages
  let lineSegment2 = monthlyAllowance === planPages + givenRolloverPages ? undefined : planPages + givenRolloverPages
  lineSegment = [lineSegment1, lineSegment2]

  let unusedPagesLabel;

  if (printedOverage < purchasedOveragePages) unusedPagesLabel = i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_OVERAGE")
  if (printedRollover < givenRolloverPages) unusedPagesLabel = i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_ROLLOVER")
  if (printedPlanPages < planPages) unusedPagesLabel = i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN")
  if (printedPlanPages < planPages && planPages < monthlyAllowance) {
    data1 = [printedPlanPages, planPages - printedPlanPages, givenRolloverPages]
    backgroundColor = [printedPlanColor, transparentColor, transparentColor]
    labels = [i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.PAGES_USED"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_PLAN"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.UNUSED_ROLLOVER")]
  }

  allInfo = {
    data: data1 ? data1 : [printedPlanPages, printedRollover, printedOverage, monthlyAllowance - printedTotalPages],
    extra: lineSegment,
    backgroundColor: backgroundColor ? backgroundColor : [printedPlanPages ? printedPlanColor : undefined, printedRollover ? rollOverColour : undefined, printedOverage ? overageColor : undefined, monthlyAllowance - printedTotalPages ? transparentColor : undefined],
    monthlyAllowance: monthlyAllowance,
    totalPagesUsed: totalPagesUsed,
    labels: labels ? labels : [i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.PAGES_USED"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.ROLLOVER"),
    i18next.t("PRINT_ACTIVITY.PAGES_USED_LABELS.OVERAGE"),
      unusedPagesLabel]
  }
  return allInfo
}

export const convertToYYYYMMDD = (originalDateString) => {
  //Parse the original date string
  let originalDate = new Date(originalDateString);
  // Format the Date object into "YYYY-MM-DD"
  let year = originalDate.getFullYear();
  let month = String(originalDate.getMonth() + 1).padStart(2, '0');
  let day = String(originalDate.getDate()).padStart(2, '0');
  let formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

export const calculateDaysBetweenDates = (startDate, endDate) => {
  let formattedStartDate = new Date(startDate);
  let formattedEndDate = new Date(endDate);
  // Convert both dates to milliseconds  
  let startDateMS = formattedStartDate.getTime();
  let endDateMS = formattedEndDate.getTime();
  // Calculate the difference in milliseconds
  let differenceMS = endDateMS - startDateMS;
  // Convert milliseconds to days
  let daysDifference = Math.ceil(differenceMS / (1000 * 60 * 60 * 24));
  return daysDifference;
}

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
};

export const handleNavigateToAppStore = (e) => {
  const appStoreType = e.currentTarget.querySelector('img').alt;
  let navigationURL = null;
  navigationURL = (appStoreType === 'andriod-app') ? EXTERNAL_LINK_ENDPOINT.googlePlayStoreAppLink : EXTERNAL_LINK_ENDPOINT.appleAppStoreLink;
  if (appStoreType === 'android-app') {
    pushDataLayer("web_signup_download_app", "app_type", "android");
  } else {
    pushDataLayer("web_signup_download_app", "app_type", "ios");
  }
  window.open(navigationURL, '_blank');
}

export const handleSubscriptionOrderPayload = async (payloadInfo) => {
  return await SubscriptionOrderPayload(null, payloadInfo);
}

//Compares only keys which are common in both the object
export const compareObjects = (obj1, obj2) => {
  if (obj1 && obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if all keys in obj1 exist in obj2
    for (const key of keys1) {
      if (!keys2.includes(key)) {
        continue;
      }
      if (obj1[key] !== obj2[key]) {
        return false; // Values are different
      }
    }
    return true; // All common values are the same
  }
  else {
    return true;
  }
}

export const Is_HWInclusive_Signup = () => {
  const SIGNUPTYPE_FLOW = getLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE);
  return (SIGNUPTYPE_FLOW === SIGNUPTYPE.HARDWARE_INCLUSIVE) ? true : false;
}

/** This method returns true when either of following conditions are met
 * 1. If the SIGNUP_TYPE is "BROTHER_PLUS" in local storage
 * 2. If the device is enrolled to BrotherPlus service (GetDeviceRegistration API response will give this info)
 */
export const Is_BrotherPlus_Signup = () => {
  let signupType = false;
  let isDeviceEnrolledToBrotherPlus = false;

  // check SIGNUP_TYPE value in local storage
  const SIGNUPTYPE_FLOW = getLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE);
  if (SIGNUPTYPE_FLOW === SIGNUPTYPE.WEB
    || SIGNUPTYPE_FLOW === SIGNUPTYPE.HARDWARE_INCLUSIVE) {
    signupType = false;
  } else if (SIGNUPTYPE_FLOW === SIGNUPTYPE.BROTHER_PLUS) {
    signupType = true
  }

  // check if device is enrolled to BrotherPlus
  isDeviceEnrolledToBrotherPlus = retreiveUserDeviceRegistrationType(USER_DEVICEREGISTRATION_TYPE_KEYS.IS_BROTHERPLUS_DEVICE);

  return (signupType || isDeviceEnrolledToBrotherPlus);
}

export const Is_BrotherPlusFreePlanSelectedFromSitecore = () => {
  const BROTHER_PLUS_FREE_PLAN = getLocalSessionData(LOCALSESSIONDATAKEYS.SITECORE_BROTHER_PLUS_PLAN);
  return (BROTHER_PLUS_FREE_PLAN) ? true : false;
}

export const getSubscriptionkindBy_SignupType = (SignupType) => {
  switch (SignupType) {
    case SIGNUPTYPE.HARDWARE_INCLUSIVE:
      return SUBSCRIPTIONKIND.HARDWARE_INCLUSIVE;
    case SIGNUPTYPE.WEB:
      return SUBSCRIPTIONKIND.WEB
    case SIGNUPTYPE.BROTHER_PLUS:
      return SUBSCRIPTIONKIND.BROTHER_PLUS
    default:
      return null;
  }
}

export const getSignupTypeBy_SubscriptionKind = (subscriptionkind) => {
  switch (subscriptionkind) {
    case SUBSCRIPTIONKIND.HARDWARE_INCLUSIVE:
    case HWINC_DEVICEUSAGE_TYPES.NEW_PRINTER_BUNDLE.NAME:
    case HWINC_DEVICEUSAGE_TYPES.REFURBISHED.NAME:
      return SIGNUPTYPE.HARDWARE_INCLUSIVE;
    case SUBSCRIPTIONKIND.WEB:
      return SIGNUPTYPE.WEB
    case SUBSCRIPTIONKIND.BROTHER_PLUS:
      return SIGNUPTYPE.BROTHER_PLUS
    default:
      return null;
  }
}

export const IsDeviceEnrolledToBrotherPlus = () => {
  return retreiveUserDeviceRegistrationType(USER_DEVICEREGISTRATION_TYPE_KEYS.IS_BROTHERPLUS_DEVICE);
}

export const IsDeviceEnrolledToEcoPro = () => {
  return retreiveUserDeviceRegistrationType(USER_DEVICEREGISTRATION_TYPE_KEYS.IS_ECOPRO_DEVICE);
}

export const IsDeviceEnrolledToBothEcoProAndBrotherPlus = () => {
  return retreiveUserDeviceRegistrationType(USER_DEVICEREGISTRATION_TYPE_KEYS.IS_BOTH_ECOPRO_BROTHERPLUS_DEVICE);
}

export const lowercaseFirstLetter = (string) => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};

export const extractKeysAsArray = (data, printerType) => {
  if (!data || typeof data !== 'object') {
    return [];
  }

  if (printerType === printerTypes.MONO_LASER) {
    return Object.keys(data).filter(key => key.toLowerCase() === 'black');
  }
  return Object.keys(data);
}
export const extractValuesAsArray = (data, printerType) => {
  if (!data || typeof data !== 'object') {
    return [];
  }
  if (printerType === printerTypes.MONO_LASER) {
    return Object.keys(data).filter(key => key.toLowerCase() === 'black').map(key => data[key]);
  }
  return Object.values(data);
}


export const getChartColors = (chartLabels) => {
  const colorMap = {
    cyan: '#A0F9FF',
    magenta: '#F05FEF',
    yellow: '#F5F44E',
    black: '#171204'
  };

  return chartLabels?.map(label => colorMap[label]);
}
/**
 * Method to handle Signup type for B+ customer
 * For Brother plus customers the signtype should be null
 * @param {string} SignupType 
 * @returns string
 */
export const handleSignUpType = (SignupType) => {
  return (SignupType !== SIGNUPTYPE.BROTHER_PLUS) ? SignupType : null
}

export const isDelayedCancellationEnabled = (subcActivatedDate) => {
  const delayCancellation_FeatureSwitch = (getFeatureSwitchByKey(featureSwitchName.DELAY_CANCELLATION)) ? true : false;
  return (subcActivatedDate && delayCancellation_FeatureSwitch) ? true : false;
}

/**
 * Method to fetch the values of query strings
 * @param {string} queryParams 
 * @param {string} key 
 * @returns string
 */
export const getQueryParamsValuesByKey = (queryParams, key) => {
  const queryParamsModified = queryParams?.split('?')[1];
  const params = new URLSearchParams(queryParamsModified);
  return params.get(key);
}
export const isBonusPagesAvailableInDiscountArray = (deviceInfoResponse) => {
  const discountInfo = deviceInfoResponse?.response?.service?.currentPlan?.discount;
  return Array.isArray(discountInfo)
    ? discountInfo?.some(obj => obj.name === ONE_TIME_BONUS)
    : false;
}
/**
 * Finds and returns a specific property value from an object in an array 
 * based on a key-value match.
 * 
 * @param {Array} array - The array of objects to search through.
 * @param {string} searchKey - The key to match in the objects.
 * @param {*} searchValue - The value to match for the given key.
 * @param {string} returnKey - The key whose value needs to be retrieved from the matching object.
 * @returns {*} - The value of the `returnKey` from the first matching object, or `null` if no match is found.
 */
export const findValueByKey_From_ArrayOfObj = (array, searchKey, searchValue, returnKey) => {
  // Validate that the input is an array
  if (!Array.isArray(array)) {
    return null;
  }
  for (const obj of array) {
    if (obj[searchKey] === searchValue) {
      return obj[returnKey];
    }
  }
  return null;
}

export const getShenlongQueryParams = (key = LOCALSESSIONDATAKEYS.NATIVE_APP_QS_INFO) => {
  return JSON.parse(getLocalSessionData(key));
}

/**
 * Method to store selected device properties into local storage
 * @param {object} deviceInfo 
 * @return void
 */
export const updateDeviceInfoToLocalStorage = (deviceInfo, deviceKeysToSessionMap) => {
  Object.keys(deviceKeysToSessionMap).forEach(function (deviceKey) {
    const sessionKey = deviceKeysToSessionMap[deviceKey];
    if (deviceInfo[deviceKey]) {
      setLocalSessionData(sessionKey, deviceInfo[deviceKey]);
    }
  });
}

const handleNativeAppAuthTokenInfo = (shenlongParams, additionalQueryParam, localStorageKey) => {
  const keysToBeRetained = ['token', 'token_type', 'expires_in', 'state'];
  // Convert existing query string to URLSearchParams for manipulation
  let existingParams = new URLSearchParams(shenlongParams || '');

  // Remove keys that are not allowed
  for (const key of [...existingParams.keys()]) {
    if (!keysToBeRetained.includes(key)) {
      existingParams.delete(key);
    }
  }

  // Add new query params from `additionalQueryParam`
  if (additionalQueryParam) {
    const newParams = new URLSearchParams(additionalQueryParam);
    for (const [key, value] of newParams.entries()) {
      existingParams.set(key, value); // This will add or update existing keys
    }
  }

  // Convert back to string and ensure it starts with `?`
  const finalQuery = '?' + existingParams.toString();
  setLocalSessionData(localStorageKey, JSON.stringify(finalQuery));
}

export const updateNativeAppQueryParams_LocalStorage = (addtionalPayload = null, additionalQueryParam = '', localStorageKey = LOCALSESSIONDATAKEYS.NATIVE_APP_QS_INFO) => {
  let shenlongParams = getShenlongQueryParams(localStorageKey);
  if (localStorageKey === LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO) {
    handleNativeAppAuthTokenInfo(shenlongParams, additionalQueryParam, localStorageKey);
  } else {
    if (shenlongParams?.params) {
      shenlongParams.params += additionalQueryParam;
    }
    setLocalSessionData(localStorageKey, JSON.stringify({ ...shenlongParams, ...addtionalPayload }));
  }
}

export const getNativeAppQueryParamsValuesByKey = (key) => {
  const { params } = getShenlongQueryParams() || {};
  return getQueryParamsValuesByKey(params, key);
}

export const isDesktopOrBmcClient = () => {
  const APP_CLIENT_ID = getNativeAppQueryParamsValuesByKey("client_id");
  const REQUEST_FROM = getNativeAppQueryParamsValuesByKey("request_from");
  return (
    APP_CLIENT_ID === NATIVE_APP_CLIENT_IDS.BMC
    || APP_CLIENT_ID === NATIVE_APP_CLIENT_IDS.DESKTOP
    || REQUEST_FROM
  )
    ? true : false;
}
/**
 * Method to build the query string for the one benefit page
 * where both EcoPro and B+ are displayed.
 * Example output: "?selection=&subscription=&brother_plus="
 */
export const buildOneBenefitPageQSNAtiveApp = (ecoproSubcStatus, bplusSubcStatus) => {
  const serviceTypeSelected = parseInt(getNativeAppQueryParamsValuesByKey("selection"));
  return `&selection=${serviceTypeSelected}&subscription=${ecoproSubcStatus}&brother_plus=${bplusSubcStatus}`;
}

/**
 * Method to build the query string for skipping auth 
 * Example output: "?cancel="
 */
export const buildSkipRegistrationQSNativeApp = (authStatus) => {
  return `&cancel=${authStatus}`;
}

/**
 * Method to build the query string when direct EcoPro and B+ benefit of supplies page are accessed.
 * Example output: "?enroll="
 */
export const buildDirectServicePageQSNativeApp = (enrollStatus) => {
  return `&enroll=${enrollStatus}`;
}

export const IsHWIncServiceNativeApp = () => {
  const serviceType = getNativeAppQueryParamsValuesByKey('service_type');
  return (serviceType === '1') ? true : false
}

export const isBplusRegistrationProcess = () => {
  const { bplusRegistration_isEnabled } = getShenlongQueryParams() || {};
  return bplusRegistration_isEnabled;
}

export const isEcoproRegistrationProcess = () => {
  const { ecoproRegistration_isEnabled } = getShenlongQueryParams() || {};
  return ecoproRegistration_isEnabled;
}

export const getCountryTranslation = (countryName) => {
  if (i18next.t(`COUNTRY_TRANSLATION.${countryName}`).includes('COUNTRY_TRANSLATION')) {
    return countryName
  }
  else {
    return i18next.t(`COUNTRY_TRANSLATION.${countryName}`)
  }
}

export const getDeviceInfoForAddNewDevice = (key) => {
  const data = JSON.parse(getLocalSessionData(LOCALSESSIONDATAKEYS.ADD_NEW_DEVICES));
  if (data === null)
    return null;
  else
    return data['device_info'][key];
}

export const isAppVersionNew = () => {
  const reqFrom = getNativeAppQueryParamsValuesByKey("request_from")
  if (!reqFrom) return false;

  const parts = reqFrom.split("_");
  const appType = parts[1];
  const version = parts[2];
  const [firstPrefix, secondPrefix] = version.split("-").map(Number);

  const rule = NATIVE_APP_VERSION_THRESHOLDS[appType];
  if (!rule) return false;

  if (rule.alwaysTrue) return true;
  if (rule.prefix === "first") return firstPrefix >= rule.min;
  if (rule.prefix === "second") return secondPrefix >= rule.min;

  return false;
};

export const isDesktopApp = () => {
  const DESKTOP_APP_REFRENCES = ["easysetup", "ips"];
  const split_request_from = getNativeAppQueryParamsValuesByKey("request_from")?.split("_");
  return (split_request_from?.length > 0) ? DESKTOP_APP_REFRENCES.includes(split_request_from[1]) : false;
}

export const isBMCApp = () => {
  const MOBILE_APP_REFRENCES = ["mobileconnect"];
  const split_request_from = getNativeAppQueryParamsValuesByKey("request_from")?.split("_");
  return (split_request_from?.length > 0) ? MOBILE_APP_REFRENCES.includes(split_request_from[1]) : false;
}

export const isEcoproOrBplusDirectServicePage = () => {
  const { params = "" } = getShenlongQueryParams() || {};
  if (params) {
    const urlObj = new URL(params);
    const pathname = urlObj.pathname;
    return (
      pathname === nativeAppRoutePaths.ECOPRO.BENEFIT_PAGE
      || pathname === nativeAppRoutePaths.BPLUS.BENEFIT_PAGE
    ) ? true : false
  } else {
    return false;
  }
}

export const flattenObjToArray = (obj) => {
  let values = [];
  for (const value of Object.values(obj)) {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      values = values.concat(flattenObjToArray(value));
    } else {
      values.push(value);
    }
  }
  return values;
}

export const isNativeAppPage = (pathname) => {
  const nativePageURLs = flattenObjToArray(nativeAppRoutePaths);
  return (nativePageURLs.includes(pathname) || pathname === routePath.SHENLONG_REDIRECT) ? true : false;
}

export const skipValidationForNativeApp = () => {
  return isDesktopOrBmcClient();
}

export const isNativeAppRequestWithRedirectURI = () => {
  const redirectURI = getNativeAppQueryParamsValuesByKey("redirect_uri");
  return (isDesktopOrBmcClient() && redirectURI) ? true : false;
}

export const isNativeAppRequestWithoutRedirectURI = () => {
  const redirectURI = getNativeAppQueryParamsValuesByKey("redirect_uri");
  return (isDesktopOrBmcClient() && !redirectURI) ? true : false;
}

export const isEnrollmentEcoPro = () => {
  if (getLocalSessionData(LOCALSESSIONDATAKEYS.ENROLLMENT_TYPE) === ENROLLMENT_TYPE.ECOPRO)
    return true;
  else
    return false;
}

export const isEnrollmentBrotherPlus = () => {
  if (getLocalSessionData(LOCALSESSIONDATAKEYS.ENROLLMENT_TYPE) === ENROLLMENT_TYPE.BROTHER_PLUS)
    return true;
  else
    return false;
}

export const ISC4CSERVICEAGENT = () => {
  return JSON.parse(getLocalSessionData(LOCALSESSIONDATAKEYS.ISC4CSERVICEAGENT));
}

export const truncateString = (str, maxLength) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength - 3) + '...';
  }
  return str;
}

export const fetchArray_From_ArrayOfObj = (array, searchKey, searchValue) => {
  // Validate that the input is an array
  if (!Array.isArray(array)) {
    return null;
  }
  for (const obj of array) {
    if (obj[searchKey] === searchValue) {
      return obj;
    }
  }
  return null;
}

export const removeNativeAppStorageItems = () => {
  removeLocalSessionData(LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO);
  removeLocalSessionData(LOCALSESSIONDATAKEYS.NATIVE_APP_QS_INFO)
}

export const getTrailContentBOSPage = (PromotionBanners, BonusPages) => {
  return PromotionBanners
    ? BonusPages
      ? <>
        <p className="bonus-savemore">{i18next.t("PROMOTION_BANNER.SAVE_MORE")}</p>
        <Trans i18nKey="EASY_SETUP.SIX_MONTH_PROMOTION.HEADER_2">
          Get a 6 months
          <span className="free-trial">FREE EcoPro trial</span>
        </Trans>
        <p>{i18next.t("EASY_SETUP.BONUS_PAGES.PAGES_FREE_COUNT", {pageCount:BONUS_PAGE_COUNT})}</p>
      </>
      : <>
        <p className="bonus-savemore">{i18next.t("EASY_SETUP.SIX_MONTH_PROMOTION.HEADER_1")}</p>
        <Trans i18nKey="EASY_SETUP.SIX_MONTH_PROMOTION.HEADER_2">
          Get a 6 months
          <span className="free-trial">FREE EcoPro trial</span>
        </Trans>
      </>
    : BonusPages
      ? <>
        <p className="bonus-savemore">{i18next.t("PROMOTION_BANNER.SAVE_MORE")}</p>
        <div>{i18next.t("PROMOTION_BANNER.TWO_OR_FOUR_MONTHS_PROMOTION")} </div>
        <div>{i18next.t("EASY_SETUP.BONUS_PAGES.PAGES_FREE_COUNT", {pageCount:BONUS_PAGE_COUNT})}</div>
      </>
      : <div>{i18next.t("PROMOTION_BANNER.TWO_OR_FOUR_MONTHS_PROMOTION")} </div>;
}

export const getEnrollmentFailureErrorMessage = (ecoproRegistrationStatus) => {
  let errorMessage = '';

  if (ecoproRegistrationStatus?.enrollStatus === "472") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "510")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.DEVICE_IS_OFFLINE")
    else if (ecoproRegistrationStatus?.enrollResponse?.code === "511")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.DEVICE_COMMUNICATION_TIMEOUT")
    else if (ecoproRegistrationStatus?.enrollResponse?.code === "599")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.DEVICE_MODE_SET_IS_FAILED_BECAUSE_OF_DEVICE_ISSUE")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else if (ecoproRegistrationStatus?.enrollStatus === "400") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "2014")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.DEVICE_ID_IS_ALREADY_IN_USE_BY_ANOTHER_SUBSCRIPTION")
    else if (ecoproRegistrationStatus?.enrollResponse?.code === "2001")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.ENROLLMENT_REQUEST_IS_DENIED_PAYMENT_STATUS_ERROR")
    else if (ecoproRegistrationStatus?.enrollResponse?.code === "1001")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.INVALID_REQUEST_PARAMETER")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else if (ecoproRegistrationStatus?.enrollStatus === "404") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "1101")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.PREENROLLID_DOES_NOT_EXIST_OR_ALREADY_CONSUMED")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else if (ecoproRegistrationStatus?.enrollStatus === "409") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "2101")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.SERVICE_CONFLICTED")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else if (ecoproRegistrationStatus?.enrollStatus === "471") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "58560030")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.UNABLE_TO_CALCULATE_CHARGE_AMOUNT")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else if (ecoproRegistrationStatus?.enrollStatus === "500") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "Other error.")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.OTHER_ERROR")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else if (ecoproRegistrationStatus?.enrollStatus === "521") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "ZuoraInternalError")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.ZUORA_INTERNAL_ERROR")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else if (ecoproRegistrationStatus?.enrollStatus === "522") {
    if (ecoproRegistrationStatus?.enrollResponse?.code === "BocInternalError")
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.BOC_INTERNAL_ERROR")
    else
      errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }
  else {
    errorMessage = i18next.t("ECOPRO_ENROLLMENT_ERROR_MESSAGE.COMMON_ERROR_MESSAGE")
  }

  return errorMessage;
}

/**
 * Method to send data to Google analytics from native app.
 */
export const trackGANativeApp = (event) => {
  const attributes = {
    request_from: getNativeAppQueryParamsValuesByKey("request_from"),
    service_status: getNativeAppQueryParamsValuesByKey("service_status"),
    utm_source: getNativeAppQueryParamsValuesByKey("utm_source"),
    utm_medium: getNativeAppQueryParamsValuesByKey("utm_medium"),
    utm_campaign: getNativeAppQueryParamsValuesByKey("utm_campaign"),
    utm_content: getNativeAppQueryParamsValuesByKey("utm_content")
  };
  pushMultipleDataLayer(event, attributes);
}

export const getNativeAppName = () => {
  const requestFrom = getNativeAppQueryParamsValuesByKey("request_from");
  return requestFrom?.split("_")?.[1];
}

export const getInkTranslation = (ink) => {
  return i18next.t(`INK_MAP.${ink.toUpperCase()}`)
}

export const getInkColorListTranslation = (list) => {
  const newList = list.map(ink =>
    getInkTranslation(ink)
  )
  return newList.join(', ');
}

export const formatAddrs = (addressObj) => {
  //convert into array
  const addressArr = Object.values(addressObj);
  const addressStr = addressArr.filter(Boolean).join(',');
  return addressStr.split(',').join(',\n');
};

export const getCountryName = (countryCode) => {
  const country = ENVSettings.COUNTRIES.find(item => item.code2 === countryCode);
  return country ? country.name : null;
}

export const getSupplyOrderConsumables = (printerType) => {
  let consumables;
  if (printerType === printerTypes.MONO_LASER) {
    consumables = [
      {
        key: "black",
        content: "Black Cartridge"
      }
    ]
  }
  else {
    consumables = [
      {
        key: "black",
        content: "Black Cartridge"
      },
      {
        key: "cyan",
        content: "Cyan Cartridge"
      },
      {
        key: "yellow",
        content: "Yellow Cartridge"
      },
      {
        key: "magenta",
        content: "Magenta Cartridge"
      }
    ]
  }

  return consumables;
}

export const mergeDeviceLists = (enrolled = [], failed = []) => {
  const map = {};

  // STEP 1: Add SUCCESS devices (primary source)
  enrolled.forEach(device => {
    const key = device.deviceId;

    const { deviceRegistrationStatus, enrolledServices, ...rest } = device;

    map[key] = {
      ...rest,
      services: {
        ecopro: null,
        brother: null
      }
    };
  });

  // STEP 2: Add FAILED devices
  failed.forEach(device => {
    const key = device.deviceId;

    const servicesList = device.enrolledServices
      ?.split(',')
      .map(s => s.trim().toLowerCase()) || [];

    // If device NOT in success → take full failed object
    if (!map[key]) {
      const { deviceRegistrationStatus, enrolledServices, ...rest } = device;

      map[key] = {
        ...rest,
        services: {
          ecopro: null,
          brother: null
        }
      };
    }

    // Only extract service-level info
    servicesList.forEach(service => {

      // EcoPro (failed case)
      if (service === USER_ENROLLED_SERVICE_LIST.ECOPRO) {
        map[key].services.ecopro = {
          isSuccess: device.isEnrollmentSuccessful,
          status: device.isEnrollmentSuccessful === false
            ? device.deviceRegistrationStatus || null
            : null
        };
      }

      // Brother
      if (service === USER_ENROLLED_SERVICE_LIST.BPLUS) {
        map[key].services.brother = {
          isSuccess: device.isEnrollmentSuccessful
        };
      }

    });
  });

  // STEP 3: Add SUCCESS services (override failed services)
  enrolled.forEach(device => {
    const key = device.deviceId;

    const servicesList = device.enrolledServices
      ?.split(',')
      .map(s => s.trim().toLowerCase()) || [];

    servicesList.forEach(service => {

      if (service === USER_ENROLLED_SERVICE_LIST.ECOPRO) {
        map[key].services.ecopro = {
          isSuccess: true,
          status: null
        };
      }

      if (service === USER_ENROLLED_SERVICE_LIST.BPLUS) {
        map[key].services.brother = {
          isSuccess: true
        };
      }

    });
  });

  // FINAL FLAGS
  return Object.values(map).map(device => {
    const eco = device.services.ecopro;
    const bro = device.services.brother;

    const isEcoSuccess = eco?.isSuccess || false;
    const isBroSuccess = bro?.isSuccess || false;

    return {
      ...device,
      isEcoProEnrollmentSuccessful: isEcoSuccess,
      isBrotherEnrollmentSuccessful: isBroSuccess,
      isEnrollmentSuccessful: isEcoSuccess || isBroSuccess
    };
  });
};


export const fetchHwIncDeviceUsageType = () => {
  const webSelectedPlanRaw = getLocalSessionData(LOCALSESSIONDATAKEYS.WEB_SELECTED_PLAN);
  const webSelectedPlan = (webSelectedPlanRaw) ? JSON.parse(webSelectedPlanRaw) : null;
  const newPrinterBundle = Number(webSelectedPlan?.HWPlans?.deviceUsageType) === HWINC_DEVICEUSAGE_TYPES.NEW_PRINTER_BUNDLE.ID;

  return newPrinterBundle
    ? HWINC_DEVICEUSAGE_TYPES.NEW_PRINTER_BUNDLE.NAME
    : HWINC_DEVICEUSAGE_TYPES.REFURBISHED.NAME;
}

export const validatesHwIncBySubscriptionKind = (subscriptionkind) => {
  return [
    HWINC_DEVICEUSAGE_TYPES.NEW_PRINTER_BUNDLE.NAME,
    HWINC_DEVICEUSAGE_TYPES.REFURBISHED.NAME
  ].includes(subscriptionkind);
}

export const redirectToBplusNativeApp = (history, isSuccess) => {
  const QS = `?success=${isSuccess ? 1 : 0}`;
  setLocalSessionData(LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO, JSON.stringify(QS));
  history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
};
/**
 * Returns the SourcePlatform payload addition object
 * @returns Object
 */
export const getSourcePlatformPayload = () => {
  return { 'SourcePlatform': (isDesktopOrBmcClient()) ? APP : WEB }
};

export const isPromotionApplicable = (plansList) => {
  if (!plansList || plansList.length === 0) return false;
  const result = plansList.filter(plan => Array.isArray(plan.discount) && plan.discount.length > 0);
  return result.length > 0;
};
